export enum FileActions {
    DOWNLOAD = 'DOWNLOAD',
    DELETE = 'DELETE',
    EDIT = 'EDIT',
    VIEW = 'VIEW',
    REORDER = 'REORDER',
    TOOLTIP_ON_HOVER = 'TOOLTIP_ON_HOVER',
    LABEL = 'LABEL'
}
